import { useTranslation } from 'react-i18next';
import {
  AFRICA_SAFARI_PRIVATE_POLICY,
  AFRICA_SAFARI_TERMS_AND_CONDITIONS,
  LanguageEnum,
  TANZANIA_SPECIALIST_PRIVATE_POLICY,
  TANZANIA_SPECIALIST_TERMS_AND_CONDITIONS,
} from 'utils/constants.ts';

import { getASSocialMediaByLanguage, getTSSocialMediaByLanguage, getLinkByLanguage } from './utils';
import FooterSection from './components/FooterSection';
import trustpilotLogo from 'assets/images/logos/trustpilot-logo.png';

interface FooterProps {
  className?: string;
}

const Footer = ({ className }: FooterProps) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language as LanguageEnum;

  return (
    <footer
      data-e2e='footer_container'
      className={`w-full bg-brand-brown bottom-0 left-0 lg:max-h-[150px] max-lg:max-h-[500px] ${className}`}
    >
      <div className='max-w-screen-xl mx-14 p-6 max-lg:p-3 flex flex-row max-lg:flex-col gap-[80px] max-lg:gap-8 justify-start max-lg:items-start'>
        <img src={trustpilotLogo} alt='Trustpilot Logo' className='w-[90px]' />
        <FooterSection
          e2e='ts'
          title={t('footer.titleTS')}
          connect={t('footer.connectWithTS')}
          termsUrl={getLinkByLanguage(TANZANIA_SPECIALIST_TERMS_AND_CONDITIONS, language)}
          privacyUrl={getLinkByLanguage(TANZANIA_SPECIALIST_PRIVATE_POLICY, language)}
          social={getTSSocialMediaByLanguage(language)}
        />

        <FooterSection
          e2e='ast'
          title={t('footer.titleAST')}
          connect={t('footer.connectWithAST')}
          termsUrl={getLinkByLanguage(AFRICA_SAFARI_TERMS_AND_CONDITIONS, language)}
          privacyUrl={getLinkByLanguage(AFRICA_SAFARI_PRIVATE_POLICY, language)}
          social={getASSocialMediaByLanguage(language)}
        />
      </div>
    </footer>
  );
};

export default Footer;
